import { createContext, FC, ReactNode, useContext } from "react";
import useWebSocket from "react-use-websocket";

import { WS_URL } from "../api/axios";

interface WebSocketContextType {
  sendMessage: (message: string) => void;
  lastMessage: MessageEvent<any> | null;
  isConnected: boolean;
}

const WebSocketContext = createContext<WebSocketContextType | null>(null);

const WebSocketProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const { sendMessage, lastMessage, readyState } = useWebSocket(WS_URL, {
    onOpen: () => {
      console.log("✅ WebSocket Connected");
    },
    onClose: (event) =>
      console.log(
        `❌ WebSocket Closed: Code ${event.code}, Reason: ${event.reason}`
      ),
    onError: (event) => console.error("🔥 WebSocket Error:", event),
  });

  const isConnected = readyState === 1;

  return (
    <WebSocketContext.Provider
      value={{ sendMessage, lastMessage, isConnected }}
    >
      {children}
    </WebSocketContext.Provider>
  );
};

export const useWebSocketContext = (): WebSocketContextType => {
  const context = useContext(WebSocketContext);
  if (!context) {
    throw new Error(
      "useWebSocketContext must be used within a WebSocketProvider"
    );
  }
  return context;
};

export default WebSocketProvider;
